export enum ShimmerElementType {
  CHECKBOX = 'checkbox',
  ROW = 'row',
  SHORT_ROW = 'short_row',
  CUSTOM = 'custom'
}
